<template>
  <section class="faq">
    <h1 class="faq-title">FAQ</h1>

    <!-- 목록 -->
    <div
      class="faq-item"
      v-for="(faq, idx) in faqList"
      :key="faq.faqId || idx"
    >
      <button
        class="faq-question"
        @click="toggleFaq($event)"
        :aria-expanded="($event?.currentTarget?.parentElement?.classList?.contains('open')) ? 'true' : 'false'"
      >
        {{ faq.question }}
        <i class="fa-solid fa-chevron-down"></i>
      </button>

      <div class="faq-answer">
        <!-- content가 HTML일 수 있으면 v-html, 텍스트면 그냥 {{ faq.content }} -->
        <p class="answer-text">{{ faq.answer }}</p>
        
      </div>
    </div>

    <!-- 빈 목록 안내 -->
    <p v-if="!faqList || faqList.length === 0" class="faq-empty">등록된 FAQ가 없습니다.</p>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex';


const store = useStore()
const router = useRouter()
const searchText = ref('')
const searchCode = ref('all')
const searchParam = computed(() => {
  return store.state.temp.searchParam
})


function toggleFaq(event) {
  const item = event.currentTarget.parentElement;
  item.classList.toggle("open");
}

const faqList = computed(() => store.state.grid.faqData)

const getGridData = async () => {
  const param = {
    pageNo: searchParam.value.pageNo,
    countPerRecord: 999,
    search: searchText.value,
    typeCd: searchCode.value
  }
  await store.dispatch('grid/faqList', param)
}

onMounted(async () => {
  await getGridData()
})

</script>

<style scoped>
.faq {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.faq-title {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

.faq-item {
  border-bottom: 1px solid #ddd;
  padding: 1rem 0;
}

.faq-question {
  width: 100%;
  text-align: left;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  margin-top: 0.5rem;
  color: #444;
  line-height: 1.6;
}

/* 열렸을 때 */
.faq-item.open .faq-answer {
  max-height: 1000px; /* 충분히 크게 잡아줘야 내용 다 펼쳐짐 */
}

.faq-item.open .faq-question i {
  transform: rotate(180deg);
}


.answer-text {
  white-space: pre-line; /* \n → 실제 줄바꿈으로 표시 */
}

</style>
